import { AxiosResponse } from "axios";
import { BASE_URL, httpClient, intanceAuth } from "../config/develop-config";

const baseUrl = `${BASE_URL}`;

export class myEvaluationDatasource {
  static getMyEvaluation(empId: number) {
    return httpClient
      .get(`${baseUrl}/pms/pms-employee/${empId}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
  static submitConsent(params: object) {
    console.log("params", params);
    return httpClient
      .post(`${baseUrl}/pms/employee-submit`, params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
